import { Component, OnInit, ViewChild, ElementRef, Input, HostListener,Renderer2  } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CatlougeTypeConstants } from '../../core/constants';
import { CommonModule, Location } from '@angular/common';
import { SearchService } from '../../core/services/search.service';
import { PageTitleService } from '../../page-services/page-title.service';
import { CommonService } from '../../core/services/common.service';
import { AssetsService, NavigationService, PlaylistService, UserService } from '../../core';
import { EventTrackingService } from '../../page-services/google/event-tracking.service';
import { FormsModule } from '@angular/forms';
import { ItemHoverComponent } from '../../shared/item-hover/item-hover.component';
import { ImageManipulationComponent } from '../../core/components/image-manipulation/image-manipulation.component';
import { LoginRegisterComponent } from '../../auth/login-register/login-register.component';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { environment } from '../../../environments/environment';
import { TranslateModule } from '@ngx-translate/core';
import { SearchRequestModel, SearchResponseModel } from './search.model';
import { SnowplowService } from '../../core/analytics/snowplow.service';
import { query } from '@angular/animations';

interface SearchResult {
  hits: any[];  // Replace 'any' with the actual type of your hits if you have it
}

interface SearchData {
  results: SearchResult[];
}
@Component({
  selector: 'app-search',
  imports: [CommonModule,FormsModule,ItemHoverComponent,ImageManipulationComponent,LoginRegisterComponent, TranslateModule],
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.css'],
  providers:[UserService, PlaylistService, CommonService]
})
export class SearchComponent {
  //livetv, movies,videos,tvshow
  hostname:any = 'NexGTv'
  searchSubscriber: any;
  private searchApiSubscription: any = null;  // tracks in-flight HTTP request
  owlOption: any;
  is_algolia: boolean = false;


  showAllRecordsTab:number =  1;
  allRecords: number = 0;

  showLiveTab:number =  0;
  liveTvRecords: number = 0;

  showMovieTab:number =  0;
  liveMoviesRecords: number = 0;

  showTvTab:number =  0;
  tvshowRecords: number = 0;

  showVideoTab:number =  0;
  videosRecords: number = 0;
  activeTab: string = 'all-tab';
  suggestionsCount: number = 0;
  searchQuery: string = "";//,hitsPerPage:10
  catlouge = CatlougeTypeConstants.catlogue;
  isParentalControlEnabled: any;
  searchTimeout: any = undefined;

  userInfo:any;
  username: string = '';
  playListId:string = '';
  @ViewChild('addToWatchListSearchSuccess') addToWatchListSuccess!:ElementRef;
  @ViewChild('itemAddedIntoWatch') itemAddedIntoWach!: ElementRef;
  error_code:string = '';
  playListAvailable: boolean = false;
  playlist: any;
  tempAsset_id: any;
  isCloudFrontType: boolean = true;
  notFoundImg:any;
  fileterDataType: any;
  allSearchResults: any[] = [];
  filteredSearchResults: any[] = [];//{ title: string, slug: string, results: any[] }[] = [];
  isAdult: string = 'no';
  isSearchResultFetched: boolean = false;
  watchlist: any[] = [];
  trendingResult: any[] = [];
  recentSearches: any[] = [];
  language: any;
  searchSuggestions: any;
  sticky: boolean = false;
  elementPosition: any;
  currentDeleteItem: string = '';
  private deleteRecentItemModalRef: NgbModalRef | null = null;
  private deleteAllRecentModalRef: NgbModalRef | null = null;
  freeIcon: string = environment.freeIcon;
  paidIcon: string = environment.paidIcon;
  queryParamSub: any;
  user_viewing_restriction:any;
  private offset  = 150;
  modalRef:any;
   assets_hover: boolean=false;
  hover_debounce_time: any;
  hoveredAssetCode: any | null = null;
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private searchSerarvice: SearchService,
    private pageTitleService: PageTitleService,
    public commonService: CommonService,
    public UserService:UserService,
    public playListService:PlaylistService,
    private modalService:NgbModal,
    private googleEvent: EventTrackingService,
    private navigationService: NavigationService,
    private assetsService: AssetsService,
    private el: ElementRef, private renderer: Renderer2,
    private snowplowService: SnowplowService
  ) { 
    this.fileterDataType = localStorage.getItem('filterTypeData');
  }

  ngOnInit(): void {
    this.language = this.commonService.languageChange();
    if (
      JSON.parse(localStorage.getItem('filterTypeData')!).search_engine != undefined &&
      JSON.parse(localStorage.getItem('filterTypeData')!).search_engine == 'algolia'
    ) {
      this.is_algolia = true
    }
    this.notFoundImg ="landscape";
    if(this.commonService.filterType ==1){
      this.isCloudFrontType = true ;
    }else{
      this.isCloudFrontType = false;
    }

    this.userInfo = JSON.parse(localStorage.getItem('userInfo')!);
    if(this.userInfo){
      this.playListId = localStorage.getItem('playListId')!;
      this.username = this.userInfo.result.user.username;
    }
    // this.pageTitleService.setTitle(`Search`);
    // let rec = ['test', 'test l', 'test s', 'test live 8', 'test live 6', 'test live 5'];
    // localStorage.setItem('recentSearches', JSON.stringify(rec));

    this.recentSearches = JSON.parse(localStorage.getItem('recentSearches')!);
    if (this.recentSearches === undefined || this.recentSearches === null) {
      this.recentSearches = []
    }
    if(localStorage.getItem('isAuthenticated')) {
      this.getWatchList();
      this.getTrending();
      this.getProfileData()
    }
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: {search: true},
      queryParamsHandling: 'merge',
    });
    setTimeout(() => {
      this.queryParamSub = this.route.queryParams.subscribe(params => {
        if (!params['search'])
          this.closeModal();
      });
    }, 0);

    //this.getProfileData()
  }


  ngAfterViewInit(){
  }

  ngOnDestroy() {
    this.queryParamSub?.unsubscribe();
    clearTimeout(this.searchTimeout);
    if (this.searchApiSubscription) {
      this.searchApiSubscription.unsubscribe();
      this.searchApiSubscription = null;
    }
    // this.route.queryParams.subscribe(queryParams => {
    //   this.router.navigate([], {
    //     relativeTo: this.route,
    //     queryParams: queryParams,
    //   });
    // });
    // this.searchSubscriber.unsubscribe();
  }
  

  closeModal(resetParams?: boolean) {
    if (resetParams) {
      const queryParams = { ...this.route.snapshot.queryParams };
      delete queryParams['search'];
  
      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: queryParams
      });
    }
    this.modalService.dismissAll();
    // try {
    //   document.querySelector("ngb-modal-window").classList.remove("show");
    //   document.querySelector("ngb-modal-backdrop").classList.remove("show");
    //   document.getElementById('nexgTV-app').click();
    //   document.querySelectorAll(".modal-backdrop").forEach(el => el.remove())
    //   document.querySelectorAll(".d-block").forEach(el => el.remove())
    //   document.body.style.overflow = "scroll";
    // } catch (e) {

    // } 
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    const scrollPosition = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;

      // scroll position fixed search nav
    // if (scrollPosition > this.offset) {
    //   this.renderer.addClass(this.el.nativeElement.querySelector('.search-nav'), 'scrolled');
    // } else {
    //   this.renderer.removeClass(this.el.nativeElement.querySelector('.search-nav'), 'scrolled');
    // }
  }

  getProfileData() {
    let url = 'profile/get';
    this.UserService.getPrfile(url).subscribe(data => {
      this.user_viewing_restriction = data?.result?.viewing_restriction?.map((item: string) => item.toLowerCase());
      
    });
  }

   getSearchResults() {
    // Cancel any in-flight search request before issuing a new one.
    // Prevents a stale (slower) response from firing a Snowplow event
    // after a newer (faster) response has already been processed.
    if (this.searchApiSubscription) {
      this.searchApiSubscription.unsubscribe();
      this.searchApiSubscription = null;
    }

    const userLanguage = localStorage.getItem('userLanguage') || 'en';
    const userInfo = JSON.parse(localStorage.getItem('userInfo') || 'null');
    const browserLang = navigator.language; // e.g. en-IN
    const headerUserCountry = browserLang.split('-')[1] || 'IN';
    const userCountry = userInfo?.result?.user?.country || headerUserCountry;

    const body: SearchRequestModel = {
      size: 120,
      query: this.searchQuery,
      page: 1,
      filters: {
        // viewer_rating: ["u", "u/a 7+", "u/a 13+", "u/a 16+", "a"],
         viewer_rating: this.user_viewing_restriction,
        lang_code: userLanguage,
        country: [userCountry],
        platforms: ["web"]
      }
  };
    this.searchApiSubscription = this.searchSerarvice.searchResults(body).subscribe((searchData: SearchResponseModel) => {
      this.searchApiSubscription = null;
      this.snowplowService.search({
        query: this.searchQuery,
        results_count: searchData.total,
      });
 
 
      // this.allSearchResults = searchData.results[0].hits.filter(item => {
      //   return item.document.type === 'livetv'
      // });
     
      this.allSearchResults = searchData.results
      // this.allSearchResults.push({source:{data:{"code": "testcode","content_availability": "FREE"}}});
      this.isSearchResultFetched = true;
      this.searchSuggestions = this.allSearchResults.map((item) => item.source.data.name);
      // FILTERED SEARCH RESULTS WILL BE IMPLEMENTED WHEN ASSET TYPES OTHER THAN LIVETV ARE REQUIRED
      // this.filteredSearchResults = this.categorizeSearchResults(this.allSearchResults);
 
    }, (error) => {
      console.error('error fetching search data: ', error);
    });
  }
  // getSearchResultsOld() {
  //   let params = {
  //     'x-typesense-api-key': JSON.parse(localStorage.getItem('filterTypeData')!).search_settings.key,
  //   }
  //   let urlEncodedParams = this.UserService.convertoJSONToUrlEncoded(params);
  //   let body = {
  //     "searches": [
  //         {
  //             query_by: "name,code,type,default_keyword,synopsis,genre_text",
  //             per_page: 50,
  //             highlight_full_fields: "name,code,type,default_keyword,synopsis,genre_text",
  //             collection: "assets_nexgtv",
  //             q: this.searchQuery,
  //             filter_by: `is_adult:${this.isAdult}`, //"type: livetv catlogue:565c8c878c86ba151d29b689 AND ",
  //             page: 1
  //         }
  //     ]
  //   }
  //   this.searchSerarvice.searchResults(urlEncodedParams, body).subscribe((searchData: any) => {
  //     // this.allSearchResults = searchData.results[0].hits.filter(item => {
  //     //   return item.document.type === 'livetv'
  //     // });
  //     this.allSearchResults = searchData.results[0].hits
  //     this.isSearchResultFetched = true;
  //     this.searchSuggestions = this.allSearchResults.map((item) => item.document.name);
  //     // FILTERED SEARCH RESULTS WILL BE IMPLEMENTED WHEN ASSET TYPES OTHER THAN LIVETV ARE REQUIRED
  //     // this.filteredSearchResults = this.categorizeSearchResults(this.allSearchResults);

  //   }, (error) => {
  //     console.error('error fetching search data: ', error);
  //   });
  // }
  
  categorizeSearchResults(allSearchResults: any) {
    let categories: any = {};

    allSearchResults.forEach((item: any) => {
      const { type } = item.document;
      if (!categories[type]) {
        let name;
        switch (type) {
          case "livetv":
          name = "Live TV";
          break;
        case "tvshow":
          name = "TV Show";
          break;
        default:
          name = type.charAt(0).toUpperCase() + type.slice(1);
          break;
      }
        categories[type] = { name: name, type: type, results: [] };
      }
      categories[type].results.push(item);
      
    });

    return Object.values(categories);
  }
  

  onSearchInput(event: any) {
    // this.searchQuery = event.target.value;
    if(this.searchQuery?.length >= 3) {
      // Cancel any previously scheduled search — prevents double-fire when
      // typing fast (e.g. "nar" → "naru" within 50ms both triggered requests)
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.getSearchResults();
      }, 300);
      this.pageTitleService.setTitle(`Search - ${this.searchQuery}`);
      // this.elementPosition = this.menuElement.nativeElement.offsetTop;
    } else {
      clearTimeout(this.searchTimeout);
      this.pageTitleService.setTitle(`Explore Devotional Content on NexGTv - Spiritual Videos & More`);
    }
  }

  searchWithField(e: any) {
    this.recentSearches.shift();
    let term = e;
    term = term.trim();
    if (term.length === 0 || !term.trim()) {
      return;
    }
    this.addToRecentSearches(term);
    this.searchQuery = term;
    this.getSearchResults();
    
  }

  addToRecentSearches(search: string) {
    this.googleEvent.eventEmitter("screen_view" , "screen_view" , this.username+'-'+'search',0,this.username , this.username+'-'+'search');
    let index = this.recentSearches.indexOf(search);
    if(index !== -1) {
      this.recentSearches.splice(index, 1);
    }
    this.recentSearches.unshift(search);
    // To limit array size
    if (this.recentSearches.length > 30) {
      this.recentSearches.pop();
    }
    localStorage.setItem('recentSearches', JSON.stringify(this.recentSearches));
  } 

  openDeleteRecentItemModal(modal: any, event: Event, search: string) {
    event.stopPropagation();
    this.deleteRecentItemModalRef = this.modalService.open(modal, {
      ariaLabelledBy: 'modal-basic-title',
      backdrop: true,
      windowClass: 'auth popup_background',
    });
    this.deleteRecentItemModalRef.result.then((result) => {
      // Handle result
    }, (reason) => {
      // Handle dismiss
    });
    this.currentDeleteItem = search;
  }

  closeDeleteRecentItemModal() {
    if (this.deleteRecentItemModalRef) {
      this.deleteRecentItemModalRef.close();
      this.deleteRecentItemModalRef = null;
    }
  }

  openDeleteAllRecentModal(modal: any, event: Event) {
    event.stopPropagation();
    this.deleteAllRecentModalRef = this.modalService.open(modal, {
      ariaLabelledBy: 'modal-basic-title',
      backdrop: true,
      windowClass: 'auth popup_background',
    });
    this.deleteAllRecentModalRef.result.then((result) => {
      // Handle result
    }, (reason) => {
      // Handle dismiss
    });
  }

  closeDeleteAllRecentModal() {
    if (this.deleteAllRecentModalRef) {
      this.deleteAllRecentModalRef.close();
      this.deleteAllRecentModalRef = null;
    }
  }

  removeFromRecentSearches(event: Event, search: string) {
    event.stopPropagation();
    let index: number = this.recentSearches.findIndex(item => search === item);
    if (index !== -1) {
      this.recentSearches.splice(index, 1);
      localStorage.setItem('recentSearches', JSON.stringify(this.recentSearches));
    }
    this.closeDeleteRecentItemModal();

  }

  clearAllRecentSearches() {
    this.recentSearches = [];
    localStorage.setItem('recentSearches', JSON.stringify(this.recentSearches));
    this.closeDeleteAllRecentModal();
  }

  onInputBlur() {
    if(this.searchQuery && this.searchQuery.length >=2) {
      this.addToRecentSearches(this.searchQuery);
    }
  }

  goto(asset: any, content: any, index: number) {
    this.userInfo = JSON.parse(localStorage.getItem('userInfo')!);

    if(this.userInfo == undefined || Object.keys(this.userInfo).length == 0){
      localStorage.setItem('preLoginRoute', this.commonService.detailRoute(asset));
      const assetData = {
        redirect_to_detail: true,
        name: asset.name,
        code: asset.code,
        type: asset.type,
      }
      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: assetData,
        queryParamsHandling: 'merge',
      });
      this.modalRef = this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title' });

      // Handle the modal close or dismiss event if needed
      this.modalRef.result.then(
        (result: any) => {
        },
        (reason: any) => {
        }
      );

      // return false;

    }
     this.snowplowService.searchResultClick({
        clicked_asset_id: asset.code || '',
        clicked_asset_name: asset.name || '',
        clicked_asset_type: asset.type || '',
        result_position: index + 1,
      });


    // let data = {
    //   "code": tempQueryStr.code,
    //   "catlogue": tempQueryStr.catlogue[0],
    //   "plateform": "web",
    //   "name": tempQueryStr.name,
    //   "charge_code": tempQueryStr.charge_code ? tempQueryStr.charge_code : '',
    //   "genre": tempQueryStr.genre ? tempQueryStr.genre : '',
    //   "type": tempQueryStr.type ? tempQueryStr.type : ''
    // }
    // data.type = data.type =='live'?'livetv':data.type;
    this.commonService.goToDetail(asset, 'Screen_Search');
    // this.router.navigate(['detail-episode'], { queryParams: data })
  }
 
  closeLoginModal(modalRef:NgbModalRef) {
    this.modalRef.close();
  }

  strToLower(str: any) {
    if (str)
      return str.toLowerCase();
    else
      return 'na';
  }

  AddToWatchList(e: any, item: any, content: any){
    e.stopPropagation();
    if(Object.keys(this.userInfo.result).length > 0) {

      let userUnique = '';
      if (this.userInfo.result.register_by == "mobile") {
        userUnique = this.userInfo.result.mobile;
      } else {
        userUnique = this.userInfo.result.emailaddress;
      }

      this.googleEvent.eventEmitter("Watchlist" , "Watchlist" , userUnique+'-'+item.code+'-'+item.name,0,userUnique , userUnique+'-'+item.code+'-'+item.name);

      let addToplayListParams = {
        playlistid:this.playListId?this.playListId:'',
        catlogue:CatlougeTypeConstants.catlogue,
        plateform:"web",
        playingtype:"Video",
        assetId:item.asset_mongo_id?item.asset_mongo_id:item._id,
        assetType:item.type?item.type:'',
        action:"saveAssetInPlaylist",
      }
  
      let urlEncodedToplayListParams = this.UserService.convertoJSONToUrlEncoded(addToplayListParams);    
      if((item.asset_mongo_id?item.asset_mongo_id:item._id) != undefined){
            this.playListService.addToPlayList(urlEncodedToplayListParams).subscribe((data)=>{
              this.error_code = data.error_code;
                if(data.error_code == '200'){
                  // this.itemAddedIntoWach.nativeElement.innerHTML = `Item Successfully added ${this.setPlayListItem?.name} into your Watchlist.`;  
                  document.getElementById('itemAddSuccessMsg')!.innerHTML= `Successfully added to Watchlist.`; 
                  this.addToWatchListSuccess.nativeElement.click(); 

                }
                if(data.error_code == '209'){
                  // this.itemAddedIntoWach.nativeElement.innerHTML = 'This item already exist in your Watchlist ';  
                  document.getElementById('itemAddSuccessMsg')!.innerHTML=`Remove from Watchlist.`;  
                  this.addToWatchListSuccess.nativeElement.click();
                  this.deleteFromWatchList(item)
                }
                
                setTimeout(()=>{
                  document.getElementById('closeAddToWatchListFromSearch')!.click();
                }, 1500);
            // this.toastr.success('Success!', '', { timeOut: 2000 });
              // this.closeAddtoWatchListModal.nativeElement.click();
  
          });
      } else {
        // this.closeAddtoWatchListModal.nativeElement.click();
      }
    } else {
      this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title'}).result.then((result) => {
      }, (reason) => {
      });
    }
  }


  getWatchList(){
    this.playListService.getPlaylist().subscribe(playlistData => {
      this.watchlist = playlistData.result;
    });
  }

  getTrending() {
    this.assetsService.getTrending().subscribe(trendingData => {
      this.trendingResult = trendingData.result;
    });
  }


  check_into_watchlist(item: any){
  }

  addToWatchlistArray(item: any) {
    this.watchlist.push(item);
    if(this.searchQuery.length > 1 && this.allSearchResults?.length > 0) {
      this.updateTrendingSearchResults(item, 1);
    }
  }

  removeFromWatchlistArray(item: any) {
    let index = this.watchlist.findIndex(ele => ele.code === item.code);
    this.watchlist.splice(index, 1);
    if(this.searchQuery.length > 1 && this.allSearchResults?.length > 0) {
      this.updateTrendingSearchResults(item, 0);
    }
  }
  
  deleteFromWatchList(item: any){
    
  }
  
  handleBack() {
    this.navigationService.back();
  }

  assetHover(asset: any) {
    const index = this.watchlist.findIndex(item => item.code === asset.code);
    this.item_hover_enter(asset)
    if (index !== -1 && (!asset?.is_watchlist_added || asset?.is_watchlist_added == 0)) {
      this.updateAllSearchResults(asset, 1);
      this.updateFilteredSearchResults(asset, 1);
    } else if (index === -1 && asset?.is_watchlist_added == 1) {
      this.updateAllSearchResults(asset, 0);
      this.updateFilteredSearchResults(asset, 0);
    }
  }

  updateTrendingSearchResults(asset: any, status: number) {
    const updatedTrendingResults = this.trendingResult.map(item => {
      if(item.code === asset.code) {
        return {
          ...item,
          is_watchlist_added: status
        };
      }
      return item;
    });

    this.trendingResult = updatedTrendingResults;
  }

  updateAllSearchResults(asset: any, status: number) {
    // Create a deep copy of allSearchResults to trigger Angular change detection
    const updatedSearchResults = this.allSearchResults.map(resultItem => {
      if (resultItem.document && resultItem.document.code === asset.code) {
      // if (resultItem.source.data.code === asset.code) {
        return {
          ...resultItem,
          document: {
            ...resultItem.document,
            is_watchlist_added: status
          }
        };
      }
      return resultItem;
    });
    // Assign the updated array back to allSearchResults
    this.allSearchResults = updatedSearchResults;
  }

  
  updateFilteredSearchResults(asset: any, status: number) {
    let ele = this.filteredSearchResults.findIndex(item => {
      return item.type === asset.type;
    });
  
    if (ele !== -1) {
      const newResultsArray = this.filteredSearchResults[ele].results.map((resultItem: any) => {
        if (resultItem.document.code === asset.code) {
          return {
            ...resultItem,
            document: {
              ...resultItem.document,
              is_watchlist_added: status
            }
          };
        }
        return resultItem;
      });
  
      let newFilteredSearchResults = [...this.filteredSearchResults];
      newFilteredSearchResults[ele] = {
        ...newFilteredSearchResults[ele],
        results: newResultsArray
      }
  
      this.filteredSearchResults = newFilteredSearchResults;
    }
  }
  
  

  updateActiveTab(event: Event) {
    const target = event.target as HTMLElement;
    const targetTab = target.getAttribute('data-target')?.substring(1); // Remove the leading '#'
    if (targetTab) {
      this.activeTab = targetTab;
    }
  }
  

  setCookie(cname: any, cvalue: any, exdays: any) {
    var d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }



  item_hover_enter(asset:any) {

      const id ='hoverPreviewVideo' + asset.code + asset?.category_slug;
     
      const el = document.getElementById(id);
      // preview video  playing of same content
    if (el) {
      console.log('el exist',el);
      return
    }
     this.assets_hover = true;
     // set time out until 'assets_hover' class append
     this.hover_debounce_time = setTimeout(() => {
      clearTimeout(this.hover_debounce_time);
       const id ='item_expend' + asset.code + asset?.category_slug;
       console.log('id',id)
        const el = document.getElementById(id);
        console.log('el',el);
        
        if (el && el.classList.contains('assets_hover')) {
            console.log('elll');
            this.hoveredAssetCode = {
              ...asset,
              item_hover: true,
              // is_preview:1
            };
            localStorage.setItem('item_hover', 'true');
        }

     }, 1000);
    
      console.log('hover owl')
    }
  item_hover_leave(asset:any, i:any) {
      clearTimeout(this.hover_debounce_time);
      this.assets_hover = false;
      this.hoveredAssetCode = {
      ...asset,
      item_hover: false
  };
}
}
